import { ILightGallerySettings } from '@ucheba/ui/components/LightGallery/types'

/** Айди предметов ЕГЭ для исключения */
export const egeSubjectsExсeptions = [34, 33, 152, 36, 421, 5]

/* Хэш для блока с группами продуктов */
export const requestHash = 'tariffs'

/* Дополнительный процент скидки при оплате сейчас */
export const additionalSale = 0

/** Настройки LightGallery */
export const lightGallerySettings = {
  autoplayFirstVideo: true,
  youtubePlayerParams: {
    controls: 0,
    showInfo: 0,
  },
  videoMaxWidth: '100%',
} as ILightGallerySettings

export const freeLessonId = 'free-lesson'

export const freeLessonHref = '#free-lesson'

export const hrefToTg =
  '/events/tg-subscribe/registration?scenario=useful_materials_subject_ege'
